import { render, staticRenderFns } from "./ReservationList.vue?vue&type=template&id=7379ed25&scoped=true&"
import script from "./ReservationList.vue?vue&type=script&lang=js&"
export * from "./ReservationList.vue?vue&type=script&lang=js&"
import style0 from "./ReservationList.vue?vue&type=style&index=0&id=7379ed25&prod&scoped=true&lang=css&"
import style1 from "./ReservationList.vue?vue&type=style&index=1&id=7379ed25&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7379ed25",
  null
  
)

export default component.exports